import { EuiTableActionsColumnType } from '@equipmentshare/ds2'

export default function getActions<T>( canEdit: boolean, openEditModal: ( productClass: T ) => void ): EuiTableActionsColumnType<T> {
	return {
		actions: [
			{
				isPrimary: true,
				name: 'Edit',
				icon: 'pencil',
				type: 'icon',
				description: 'Edit product class',
				enabled: () => canEdit,
				onClick: openEditModal,
			}
		],
		name: 'Actions',
	}
}
